import { DrawingManager } from "@react-google-maps/api";
import { useEffect } from "react";

const MapaDrawingManager = ({ drawingManagerKey, polyRef, setPoligono, drawingManagerRef, handleConsultarPontos, setModoAtivo, modoAtivo }) => {
    const handlePoligonoComplete = (poly) => {
        const path = poly.getPath().getArray();

        polyRef.current = poly;

        const coordenadas = path.map((latLng, index) => ({
            NumeroPonto: index + 1,
            Latitude: latLng.lat().toString(),
            Longitude: latLng.lng().toString()
        }));

        if (coordenadas.length > 0) {
            coordenadas.push({
                NumeroPonto: coordenadas.length + 1,
                Latitude: coordenadas[0].Latitude,
                Longitude: coordenadas[0].Longitude,
            });
        }

        setPoligono(coordenadas);
        handleConsultarPontos(coordenadas);
        setModoAtivo('mao');
    }

    useEffect(() => {
        const alterarLayout = () => {
            if (drawingManagerRef.current) {
                modoAtivo === "mao" ?
                drawingManagerRef.current.setDrawingMode(null) :
                drawingManagerRef.current.setDrawingMode(window.google.maps.drawing.OverlayType.POLYGON)
            }
        };

        alterarLayout();
    }, [modoAtivo, drawingManagerRef.current]);

    return (
        <div style={{ display: 'none' }}>
            <DrawingManager
                key={`drawing-${drawingManagerKey}`}
                options={{
                    drawingControl: false,
                    drawingModes: ['polygon'],
                    polygonOptions: {
                        fillColor: '#000000',
                        fillOpacity: 0,
                        strokeWeight: 2,
                        strokeColor: '#000000',
                        clickable: true,
                        editable: true,
                        draggable: false,
                    },
                }}
                onPolygonComplete={handlePoligonoComplete}
                onLoad={(dm) => {
                    drawingManagerRef.current = dm;
                }}
            />
        </div>
    )
}

export default MapaDrawingManager;